import TextFormatter from '@intercom/embercom-composer/components/text-formatter';
export default TextFormatter;
